import React from 'react';
import '../styles/ContactInformations.css';
import PhoneIcon from '../assets/icons/phone.svg';
import EmailIcon from '../assets/icons/email.svg';
import LocationIcon from '../assets/icons/location.svg';

function ContactInformations() {

    const ContactInfo  = [
        {
            title: "Odwiedź nas!",
            adress: "Sami Swoi, ul. Włókniarzy 1, 34-120 Andrychów",
            openingHours1: "poniedziałek - czwartek: 11:00 - 22:00",
            openingHours2: "piątek, sobota: 11:00 - 24:00",
            openingHours3: "niedziela i dni świąteczne: 12:00 - 22:00",
            icon: LocationIcon
        },
        {
            title: "Zadzwoń do nas!",
            tel: "+48 795 596 427",
            icon: PhoneIcon
        },
        {
            title: "Napisz do nas!",
            email: "samiswoi@onet.eu",
            icon: EmailIcon
        }
    ]

    return (
            <div className="container-fluid my-5-5 py-5 text-white contact-with-us-section-background">
                <div className="container">
                    <div className="row">
                        <div className='text-center mb-5'>
                            <h4 className='fs-3'>Skontaktuj się z naszą załogą</h4>
                            <hr className='divider' />
                            <p className='fw-light'>Porozmawiaj z nami!</p>
                        </div>
                        <div className="col-12 col-md-6 contact-cards-container mb-5">
                            {ContactInfo.map((item,index) => {
                                return (
                                    <div key={index} className="contact-card py-3">
                                        <img src={item.icon} alt='icon' className='icon icon-large p-0 mt-3 mb-3' />
                                        <h4>{item.title}</h4>
                                        <p className="fw-light fs-5">{item.adress}</p>
                                        <a href='mailto:samiswoi@onet.eu' className='text-white text-decoration-none fw-light fs-5'>{item.email}</a>
                                        <a href='tel:795596427' className='text-white text-decoration-none fw-light fs-5'>{item.tel}</a>
                                        <p className="fw-lighter my-1">{item.openingHours1}</p>
                                        <p className="fw-lighter my-1">{item.openingHours2}</p>
                                        <p className="fw-lighter my-1">{item.openingHours3}</p>
                                    </div>
                                )
                            })}
                        </div>
                        <div className="col-12 col-md-6">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10288.840980112323!2d19.338514581417044!3d49.85729517742947!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x471685393a41e93f%3A0x5b747c88aee66de1!2sSami%20Swoi!5e0!3m2!1sen!2spl!4v1731858922830!5m2!1sen!2spl" allowFullScreen className='map shadow' loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div>
                </div>
            </div>
    )

}

export default ContactInformations;